import axiosInstance from '../../../config/axiosInstance';
const OppurtunityService = {
    async GetAllOppurtunities(redirectCallback,Start, PageSize, searchQuery, sortColumn, sortDirection,EmailingName = "",SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Oppurtunity/GetAllOppurtunities?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllOpportunityForQuotations(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Oppurtunity/GetAllOpportunityForQuotations?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetOpportunityCount(redirectCallback,searchQuery,EmailingName = "",SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Oppurtunity/GetOpportunityCount?ClientID=${ClientID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetOppurtunityByID(redirectCallback,ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Oppurtunity/GetOppurtunityByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteOppurtunity(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Oppurtunity/DeleteOppurtunity?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LockOpportunity(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Oppurtunity/LockOpportunity?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockOpportunity(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Oppurtunity/UnLockOpportunity?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetOpportunityForExport(redirectCallback,Start, PageSize, searchQuery, sortColumn, sortDirection) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Oppurtunity/GetOpportunityForExport?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default OppurtunityService;